import { useEffect } from 'react';

function useEscapeButton(onEcape) {
  useEffect(() => {
    function handleClickOutside(e) {
      if (e.key === 'Escape') {
        onEcape();
      }
    }

    document.addEventListener('keydown', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleClickOutside);
    };
  });
}

export default useEscapeButton;
